import { localStorageNameEnum } from "../models/constants";
import { statusMessages } from "./httpService";

const isDev = process.env.REACT_APP_USER_BRANCH === "dev";

/**
 * Returns only two variants of the result:
 *  1) In case of successful result:  { blob, contentType }
 *  2) When something goes wrong: { error: <error message> }
 * @param {{ photoId: string; }} props
 * @returns {Promise<{ blob: Blob; contentType: string; } | { error: string; }>}
 */
export const httpDownloadService = async ({ photoId }) => {
  const storedToken = window.sessionStorage.getItem(
    localStorageNameEnum.AUTH_TOKEN
  );

  const headers = {};
  headers.Authorization = `Bearer ${storedToken}`;

  try {
    const response = await fetch(
      `${
        isDev
          ? process.env.REACT_APP_API_DEV_URL
          : process.env.REACT_APP_API_URL
      }/user/details/photo/${photoId}`,
      {
        // @ts-ignore
        headers,
        method: "GET",
      }
    );

    if (response?.status !== 200) {
      throw new Error(statusMessages[response?.status]);
    }

    const contentType = response?.headers?.get("Content-Type");
    const blob = await response.blob();

    return {
      blob,
      contentType,
    };
  } catch (error) {
    console.error(`httpService`, error);
    return {
      error: String(error.message).replace(/Error:/g, ""),
      // error: 'Network error'
    };
  }
};
